import { defaultTheme } from 'react-admin'
import merge from 'lodash/merge'

const customTheme = merge({}, defaultTheme, {})

export default customTheme
